export const MAX_UPLOAD_BYTES = 524288000;
export const MAX_UPLOAD_LABEL = '500 MB';

export function isWithinUploadLimit(file) {
    return file.size <= MAX_UPLOAD_BYTES;
}

export function uploadSizeErrorMessage() {
    return `File exceeds the ${MAX_UPLOAD_LABEL} upload limit.`;
}

export function getUploadErrorMessage(error) {
    if (error?.response?.status === 413) {
        return error.response.data || uploadSizeErrorMessage();
    }
    return null;
}
